export default __webpack_public_path__ + "static/media/25082602.dc2c06ba.jpg";